import React, { useState } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import { SavedChatsPage } from './SavedChatsPage';
import { useIdentity } from '../context/IdentityContext';
import { MessageSquare } from 'lucide-react';

export const ShadowChatLayout = () => {
    const { identityMode } = useIdentity();
    const location = useLocation();
    const [showMobileSavedChats, setShowMobileSavedChats] = useState(false);

    // Check if we're exactly at /chat or if we have an active child route.
    const isRoot = location.pathname === '/chat' || location.pathname === '/chat/';

    return (
        <main className="w-full sm:w-[700px] lg:w-[1050px] h-screen sm:h-screen flex shrink-0 bg-black overflow-hidden relative">
            {/* Left Panel: Saved Chats List */}
            <div className={`w-full sm:w-[400px] border-r border-gray-800 h-full overflow-hidden flex-col shrink-0 ${isRoot ? (showMobileSavedChats ? 'flex sm:flex' : 'hidden sm:flex') : 'hidden sm:flex'}`}>
                <SavedChatsPage isEmbedded={true} onBackToMode={() => setShowMobileSavedChats(false)} />
            </div>

            {/* Right Panel: Chat Interface */}
            <div className={`flex-1 h-full overflow-hidden flex-col relative bg-[#0a0a0a] ${isRoot && showMobileSavedChats ? 'hidden sm:flex' : 'flex'}`}>
                {identityMode === 'real' ? (
                    <div className="flex-1 flex flex-col items-center justify-center p-8">
                        <div className="w-16 h-16 rounded-full bg-[#0BD9E5]/20 text-[#0BD9E5] flex items-center justify-center mb-6">
                            <MessageSquare size={32} />
                        </div>
                        <h2 className="text-[31px] font-extrabold mb-2 leading-tight text-center text-white">Chat</h2>
                        <p className="text-gray-500 text-[15px] text-center">Coming soon for Real Identity mode.</p>
                    </div>
                ) : (
                    <Outlet context={{ onToggleMobileSavedChats: () => setShowMobileSavedChats(prev => !prev) }} />
                )}
            </div>
        </main>
    );
};

export default ShadowChatLayout;
